import { ref } from 'vue';

// Module-level: ShiftView writes, AppShell reads — no polling, no DB calls in shell
export const activeSession = ref(null); // { clockIn: ISO string, workplace: string, entryType: string } | null
